import { useEffect } from 'react';
import { clickTaleStart, clickTaleEnd } from 'utilities/clickTale';
import { ADDITIONAL_TEXT, ADDITIONAL_TOOLTIP } from 'constants/cms';
import { stopPolling } from 'actions/polling';

export const useInitProfileStep1OnMount = ({ initialStep, cmsActions, preLoaderActions }) => {
    useEffect(() => {
        if (initialStep.get('fromInitialStep')) preLoaderActions.hidePreLoader();
        cmsActions.getCMS(ADDITIONAL_TEXT, ADDITIONAL_TOOLTIP);
        clickTaleStart();

        return () => {
            clickTaleEnd();
            stopPolling();
        };
    }, []);
};
